/* Extrait du bloc {% javascript %} de snippets/lcu-wizard-reviews.liquid.
   Shopify concatenait tous ces blocs dans compiled_assets/scripts.js,
   telecharge et EXECUTE sur toutes les pages, y compris celles qui ne
   rendent pas la section. Ce fichier ne part plus qu'avec elle.

   Le garde ci-dessous reproduit le comportement d'origine : Shopify
   n'executait le bloc qu'une fois par type de section, alors qu'une
   balise <script src> peut etre emise plusieurs fois si la section est
   ajoutee deux fois sur une page. */

if (!window.__lcuScriptsRun) window.__lcuScriptsRun = {};
if (!window.__lcuScriptsRun.lcu_wizard_reviews) {
  window.__lcuScriptsRun.lcu_wizard_reviews = true;

  (function () {
    function initReviews(root) {
      var items = root.querySelectorAll('[data-reviews-item]');
      if (items.length < 2) return;

      var prev = root.querySelector('[data-reviews-prev]');
      var next = root.querySelector('[data-reviews-next]');

      /*
       * Ordre de passage : le premier avis du snippet est epingle (c'est la
       * vitrine, tout le monde doit le voir), les suivants sont melanges a
       * chaque chargement. Avant, la rotation suivait l'ordre du DOM : a
       * 5 secondes par avis, personne n'allait au-dela du troisieme et les
       * douze autres ne servaient a rien.
       *
       * Le melange se fait ici et pas en Liquid : la page produit passe par le
       * CDN Shopify, un tirage cote serveur serait fige pour tous les
       * visiteurs qui tombent sur la meme copie en cache.
       */
      var order = [];
      for (var n = 1; n < items.length; n++) order.push(n);
      for (var s = order.length - 1; s > 0; s--) {
        var r = Math.floor(Math.random() * (s + 1));
        var swap = order[s];
        order[s] = order[r];
        order[r] = swap;
      }
      order.unshift(0);

      /* Position dans `order`, pas l'index de l'avis dans le DOM. */
      var index = 0;
      var timer = null;
      var paused = false;
      var offscreen = false;
      var stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /*
       * Le rang annonce suit la rotation, pas l'ordre du DOM : apres melange,
       * le deuxieme avis montre pouvait s'annoncer « Avis 12 sur 15 » et le
       * compteur se lisait comme casse. Seul l'avis affiche est reetiquete,
       * les autres sont en `visibility: hidden` donc hors de l'arbre
       * d'accessibilite. Le libelle rendu par Liquid reste le repli sans JS.
       */
      var positionTemplate = root.getAttribute('data-reviews-position');

      function show(target) {
        index = (target + order.length) % order.length;
        var active = order[index];
        for (var i = 0; i < items.length; i++) {
          items[i].classList.toggle('is-active', i === active);
        }
        if (positionTemplate) {
          items[active].setAttribute('aria-label', positionTemplate.replace('{n}', index + 1));
        }
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (stopped || paused || offscreen) return;
        timer = setInterval(function () {
          show(index + 1);
        }, 5000);
      }

      function manual(step) {
        stopped = true;
        stop();
        show(index + step);
      }

      if (prev) prev.addEventListener('click', function () { manual(-1); });
      if (next) next.addEventListener('click', function () { manual(1); });

      root.addEventListener('pointerenter', function () { paused = true; stop(); });
      root.addEventListener('pointerleave', function () { paused = false; start(); });
      root.addEventListener('focusin', function () { paused = true; stop(); });
      root.addEventListener('focusout', function () { paused = false; start(); });

      if (typeof IntersectionObserver === 'function') {
        new IntersectionObserver(function (entries) {
          offscreen = !entries[0].isIntersecting;
          start();
        }, { threshold: 0.5 }).observe(root);
      } else {
        start();
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-wizard-reviews]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].dataset.reviewsReady) {
          roots[i].dataset.reviewsReady = '1';
          initReviews(roots[i]);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
}
